<div class="app-shell">
  @if (isLoading$ | async) {
    <div class="splash">
      <div class="splash-content">
        <div class="logo">
          <span class="logo-img" role="img" aria-label="Tive"></span>
          <span class="logo-labs">AI LABS</span>
        </div>
        <div class="spinner"></div>
      </div>
    </div>
  } @else if (isAuthenticated$ | async) {
    <app-warning-banner />
    @if (session.initError()) {
      <div class="splash">
        <div class="splash-content">
          <div class="logo">
            <span class="logo-img" role="img" aria-label="Tive"></span>
            <span class="logo-labs">AI LABS</span>
          </div>
          <p class="error-text">{{ session.initError() }}</p>
          <div class="error-actions">
            <button class="btn-primary" (click)="retry()">Try again</button>
            <button class="btn-secondary" (click)="logout()">Log out</button>
          </div>
        </div>
      </div>
    } @else if (!session.initialized()) {
      <div class="splash">
        <div class="splash-content">
          <div class="logo">
            <span class="logo-img" role="img" aria-label="Tive"></span>
            <span class="logo-labs">AI LABS</span>
          </div>
          <div class="spinner"></div>
        </div>
      </div>
    } @else if (!session.hasLabsAccess()) {
      <div class="landing-layout">
        <!-- LEFT: Content -->
        <div class="landing-left">
          <div class="logo">
            <span class="logo-img" role="img" aria-label="Tive"></span>
            <span class="logo-labs">AI LABS</span>
          </div>
          <h1 class="landing-headline">Visibility.<br />Reimagined.</h1>
          <p class="landing-description">
            We're deeply collaborating with our customers to develop new visibility products at a
            rapid pace. Products available through Tive AI Labs are still being perfected, but made
            available to select customers eager to experiment and share critical feedback with us.
          </p>
          <div class="actions">
            <a class="btn-primary" [href]="platformUrl">Go to Tive Platform</a>
            <button class="btn-secondary" (click)="logout()">Log out</button>
          </div>
          <div class="cta-box">
            <p class="cta-box-eyebrow">Early Access Program</p>
            <h2 class="cta-box-heading">Join the conversation</h2>
            <p class="cta-box-body">
              Fill out the interest form and we'll schedule time to brainstorm together. Before you
              know it, we'll deliver new products for you to try.
            </p>
            <div
              class="typeform-embed"
              appTypeformLoad
              data-tf-live="01KKMHTDP4PJBVK0X2Z4N0NX3M"
            ></div>
          </div>
        </div>
        <!-- RIGHT: Radar visual -->
        <div class="landing-right" aria-hidden="true">
          <div class="radar">
            <div class="ring"></div>
            <div class="ring"></div>
            <div class="ring"></div>
            <div class="ring"></div>
            <div class="radar-sweep"></div>
            <div class="blip"></div>
            <div class="blip"></div>
            <div class="blip"></div>
            <div class="blip"></div>
            <div class="blip"></div>
            <div class="radar-center"></div>
          </div>
          <p class="radar-label">Live Visibility Network</p>
        </div>
      </div>
    } @else {
      <router-outlet />
    }
  } @else {
    <div class="landing-layout">
      <!-- LEFT: Content -->
      <div class="landing-left">
        <div class="logo">
          <span class="logo-img" role="img" aria-label="Tive"></span>
          <span class="logo-labs">AI LABS</span>
        </div>
        <h1 class="landing-headline">Visibility.<br />Reimagined.</h1>
        <p class="landing-description">
          We're deeply collaborating with our customers to develop new visibility products at a
          rapid pace. Products available through Tive AI Labs are still being perfected, but made
          available to select customers eager to experiment and share critical feedback with us.
        </p>
        <button class="btn-login" (click)="login()">Log in</button>
        <div class="cta-box">
          <p class="cta-box-eyebrow">Early Access Program</p>
          <h2 class="cta-box-heading">Join the conversation</h2>
          <p class="cta-box-body">
            Fill out the interest form and we'll schedule time to brainstorm together. Before you
            know it, we'll deliver new products for you to try.
          </p>
          <div class="typeform-embed" data-tf-live="01KKMHTDP4PJBVK0X2Z4N0NX3M"></div>
        </div>
        <p class="tive-link">
          Not a Tive customer yet?
          <a href="https://tive.com" target="_blank" rel="noopener">Learn more at tive.com</a>
        </p>
      </div>
      <!-- RIGHT: Radar visual -->
      <div class="landing-right" aria-hidden="true">
        <div class="radar">
          <div class="ring"></div>
          <div class="ring"></div>
          <div class="ring"></div>
          <div class="ring"></div>
          <div class="radar-sweep"></div>
          <div class="blip"></div>
          <div class="blip"></div>
          <div class="blip"></div>
          <div class="blip"></div>
          <div class="blip"></div>
          <div class="radar-center"></div>
        </div>
        <p class="radar-label">Live Visibility Network</p>
      </div>
    </div>
  }
</div>
